import type { ProjectDetail } from '@/types/odoo';
import { OfferteContent } from './OfferteContent';

interface DashboardOfferteSectionProps {
  detail: ProjectDetail;
  /** Rendered inside a DashboardSection shell — suppresses the standalone heading. */
  embedded?: boolean;
}

/**
 * Dashboard Offerte section — the standalone OfferteTab's UI, rendered from the
 * project-detail payload that DashboardTab already holds. No own fetch: `saleOrders`
 * (+ legacy single-SO fallback) and `partnerWarning` come down in `detail`, and the
 * server has already applied any role-based amount-stripping upstream.
 *
 * Embedded in the dashboard the customer warning already sits at the top
 * (DashboardTab), so repeating it here would show it twice.
 */
export function DashboardOfferteSection({ detail, embedded }: DashboardOfferteSectionProps) {
  return (
    <OfferteContent
      saleOrders={detail.saleOrders ?? []}
      saleOrder={detail.saleOrder}
      lines={detail.saleOrderLines}
      partnerWarning={embedded ? null : detail.partnerWarning}
      embedded={embedded}
    />
  );
}
